import {ref} from "vue";

const oldEmail = ref("");
const newEmail = ref("");
const pendingEmailAddress = ref(null);

function clearState() {
  oldEmail.value = "";
  newEmail.value = "";
  pendingEmailAddress.value = null;
}

export function useEmailChange() {
  return {oldEmail, newEmail, pendingEmailAddress, clearState};
}
